"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _color = require("color");

var _color2 = _interopRequireDefault(_color);

var _palette = require("./palette");

var _palette2 = _interopRequireDefault(_palette);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  colors: {
    primary: _palette2.default.blue["600"],
    secondary: _palette2.default.ink["700"],
    alert: _palette2.default.red["700"],
    white: _palette2.default.white.normal,
    pink: _palette2.default.pink.normal,
    palette: _palette2.default
  },
  buttons: {
    primary: {
      color: _palette2.default.white.normal,
      backgroundColor: _palette2.default.blue["600"],
      "&:hover": {
        backgroundColor: _palette2.default.blue["700"]
      },
      "&:active": {
        backgroundColor: _palette2.default.blue["800"]
      },
      "svg > path": {
        fill: _palette2.default.white.normal
      }
    },
    secondary: {
      color: _palette2.default.ink["700"],
      backgroundColor: _palette2.default.ink["100"],
      "&:hover": {
        backgroundColor: _palette2.default.ink["200"]
      },
      "&:active": {
        backgroundColor: _palette2.default.ink["300"]
      },
      "svg > path": {
        fill: _palette2.default.ink["700"]
      }
    },
    destructive: {
      color: _palette2.default.white.normal,
      backgroundColor: _palette2.default.red["700"],
      "&:hover": {
        backgroundColor: _palette2.default.red["800"]
      },
      "&:active": {
        backgroundColor: _palette2.default.red["900"]
      },
      "svg > path": {
        fill: _palette2.default.white.normal
      }
    },
    destructiveBordered: {
      color: _palette2.default.red["700"],
      backgroundColor: _palette2.default.ink["100"],
      "&:hover": {
        backgroundColor: _palette2.default.ink["200"]
      },
      "&:active": {
        backgroundColor: _palette2.default.ink["300"]
      },
      "svg > path": {
        fill: _palette2.default.red["700"]
      }
    },
    primaryBordered: {
      color: _palette2.default.blue["600"],
      backgroundColor: _palette2.default.ink["100"],
      "&:hover": {
        backgroundColor: _palette2.default.ink["200"]
      },
      "&:active": {
        backgroundColor: _palette2.default.ink["300"]
      },
      "svg > path": {
        fill: _palette2.default.blue["600"]
      }
    },
    disabled: {
      pointerEvents: "none"
    }
  },
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64],
  fontWeights: [400, 500, 600, 700],
  lineHeights: ["16px", "20px", "24px", "28px", "36px", "48px", "72px", "96px"],
  space: [0, 4, 8, 16, 24, 32, 64, 128, 256],
  borders: [0, "1px solid", "2px solid", "4px solid", "8px solid", "16px solid", "32px solid"],
  sizes: [16, 24, 32, 48, 64, 128, 256, 512, 1024],
  opacity: [0.3, 0.5, 0.8],
  fonts: {
    normal: "'Helvetica Neue', Helvetica, Arial, sans-serif", // eslint-disable-line
    mono: '"SFMono-Regular", "Roboto Mono", "Menlo", monospace'
  },
  duration: ["0.4s", "0.3s", "0.15s"],
  transition: {
    default: "ease-in-out"
  },
  breakpoints: ["40em", "52em", "64em"],
  shadows: {
    actionable: `0 2px 3px 0 ${(0, _color2.default)(_palette2.default.ink["900"]).alpha(0.2).rgb()}`,
    elevated: `0 2px 3px 0 ${(0, _color2.default)(_palette2.default.ink["900"]).alpha(0.3).rgb()}`,
    modal: `0 4px 6px 0 ${(0, _color2.default)(_palette2.default.ink["900"]).alpha(0.4).rgb()}`
  },
  /* TODO: Deprecate boxShadow key in favor of shadows. */
  boxShadow: {
    static: "0px 0px 3px 1px",
    actionable: "0 2px 3px 0",
    elevated: "0 2px 3px 0",
    modal: "0 4px 6px 0",
    colorStatic: (0, _color2.default)(_palette2.default.blue["600"]).alpha(0.3).hex(),
    colorActionable: (0, _color2.default)(_palette2.default.ink["900"]).alpha(0.2).hex(),
    colorElevated: (0, _color2.default)(_palette2.default.ink["900"]).alpha(0.3).hex(),
    colorModal: (0, _color2.default)(_palette2.default.ink["900"]).alpha(0.4).hex()
  },
  messages: {
    default: {
      backgroundColor: _palette2.default.ink["100"],
      color: _palette2.default.ink["900"]
    },
    success: {
      backgroundColor: _palette2.default.green["000"],
      color: _palette2.default.green["900"]
    },
    alert: {
      backgroundColor: _palette2.default.red["000"],
      color: _palette2.default.red["900"]
    },
    info: {
      backgroundColor: _palette2.default.blue["000"],
      color: _palette2.default.blue["900"]
    }
  },
  spinners: {
    large: {
      width: 48,
      height: 48,
      "> *": {
        cx: "50%",
        cy: "50%",
        r: 22,
        fill: "transparent",
        strokeWidth: 3,
        strokeLinecap: "round",
        strokeDasharray: 144,
        strokeDashoffset: 72
      }
    },
    medium: {
      width: 40,
      height: 40,
      "> *": {
        cx: "50%",
        cy: "50%",
        r: 18,
        fill: "transparent",
        strokeWidth: 3,
        strokeLinecap: "round",
        strokeDasharray: 120,
        strokeDashoffset: 60
      }
    },
    small: {
      width: 32,
      height: 32,
      "> *": {
        cx: "50%",
        cy: "50%",
        r: 14,
        fill: "transparent",
        strokeWidth: 3,
        strokeLinecap: "round",
        strokeDasharray: 96,
        strokeDashoffset: 48
      }
    },
    xsmall: {
      width: 24,
      height: 24,
      "> *": {
        cx: "50%",
        cy: "50%",
        r: 10,
        fill: "transparent",
        strokeWidth: 3,
        strokeLinecap: "round",
        strokeDasharray: 72,
        strokeDashoffset: 36
      }
    },
    xxsmall: {
      width: 16,
      height: 16,
      "> *": {
        cx: "50%",
        cy: "50%",
        r: 6,
        fill: "transparent",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeDasharray: 48,
        strokeDashoffset: 24
      }
    }
  }
};